<template src="../template/welcome.html"></template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { getCookie, setCookie } from '../utils/cacheUtil'
import { startToWatchGps, sendGeoLocation } from '../utils/geolocationUtil'
import { initFingerPrint } from '../utils/fingerPringUtil'
import { uuid } from 'vue-uuid'
import CheckUtil from '../utils/checkUtil'
import _ from 'lodash'
import Vue from 'vue'

export default {
  name: 'Welcome',
  data: function () {
    return {
      projectId: '',
      projectOfficialSite: '',
      isQrCodeRequired: true,
      customizeBackGroundColor: '',
      customizeBackGroundImage: 'images/img_bg.svg',
      customizeLogo: '',
      customizeInitialLongitude: '',
      customizeInitialLatitude: '',
      customizePublicUtilities: [],
      isClientBoxActive: false,
      isLoginRequired: false,
      isDataCollectionRequired: false,
      isGenderForDataCollectionRequired: false,
      isAgeForDataCollectionRequired: false,
      isNicknameForDataCollectionRequired: false,
      isTrackingAllowed: '',
      customizeFooterText: ''
    }
  },
  beforeCreate () {
    window.localStorage.clear()
    window.sessionStorage.clear()
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
    }
  },
  computed: {
    ...mapState(['PROJECT_ID', 'QR_CODE', 'EXT_CUSTOM_INIT_LON', 'EXT_CUSTOM_INIT_LAT', 'EXT_CUSTOM_PUB_UTILS', 'IS_TRACKING_ALLOWED', 'ALL_MARKERS', 'SHOW_LOCAL_NAME', 'GUIDE_LIST']),
    ...mapGetters(['getProjectId', 'getQRCode', 'getExtCustomInitLon', 'getExtCustomInitLat', 'getExtCustomPubUtils', 'getIsTrackingAllowed', 'getAllMarkers', 'getShowLocalName', 'getGuides'])
  },
  methods: {
    ...mapMutations(['setProjectId', 'setQRCode', 'setUserName', 'setExtCustomInitLon', 'setExtCustomInitLat', 'setExtCustomPubUtils', 'setIsTrackingAllowed']),
    setProjectExtConfig () {
      Vue.axios.get('/config/project-config-ext.json').then((response) => {
        const data = response.data.filter(d => d.projectId === this.$route.params.prjId)
        if (!_.isNull(data) && !_.isEmpty(data)) {
          const projectConfig = data[0]
          // this.projectId = projectConfig.projectId
          // this.setProjectId(this.projectId)
          this.projectOfficialSite = projectConfig.projectOfficialSite
          window.localStorage.setItem('projectOfficialSite', this.projectOfficialSite)
          this.isQrCodeRequired = projectConfig.isQrCodeRequired
          const autoGenQRCode = 'followAppWebGen-' + uuid.v4()
          if (!this.isQrCodeRequired) {
            this.setQRCode(autoGenQRCode)
          }
          this.customizeBackGroundColor = projectConfig.customizeBackGroundColor
          this.customizeBackGroundImage = projectConfig.customizeBackGroundImage
          this.customizeLogo = projectConfig.customizeLogo
          this.customizeFooterText = projectConfig.customizeFooterText
          this.customizeInitialLongitude = projectConfig.customizeInitialLongitude
          this.setExtCustomInitLon(projectConfig.customizeInitialLongitude)
          this.customizeInitialLatitude = projectConfig.customizeInitialLatitude
          this.setExtCustomInitLat(projectConfig.customizeInitialLatitude)
          this.customizePublicUtilities = projectConfig.customizePublicUtilities
          this.setExtCustomPubUtils(JSON.stringify(projectConfig.customizePublicUtilities))
          this.isClientBoxActive = true
          this.isLoginRequired = projectConfig.isLoginRequired
          this.isDataCollectionRequired = projectConfig.isDataCollectionRequired
          if (!projectConfig.isLoginRequired) {
            window.localStorage.setItem('userId', autoGenQRCode)
          }
        }
      })
        .catch((e) => {
          // // console.error(e)
        })
    },
    setTrackingAllowed () {
      this.setIsTrackingAllowed('Y')
      this.isTrackingAllowed = 'Y'
    },
    goToExhibition () {
      this.$router.push({ name: 'exhibition' })
    }
  },
  created: function () {
    CheckUtil.browserReloadCheck()
    this.setProjectExtConfig()
    initFingerPrint()

    if (!_.isEmpty(this.$route.params.prjId)) {
      this.setProjectId(this.$route.params.prjId)
    }
    if (!_.isEmpty(this.$route.params.qrCode) && this.isQrCodeRequired) {
      this.setQRCode(this.$route.params.qrCode)
    }

    if (getCookie('follow-session') === null) {
      const maxAge = this.isLoginRequired ? 60 * 60 * 24 : null
      setCookie('follow-session', 'visit', maxAge)
    }
    if (window.localStorage.getItem('gpsTimeID') !== null) {
      clearInterval(parseInt(window.localStorage.getItem('gpsTimeID')))
      window.localStorage.removeItem('gpsTimeID')
    }
    startToWatchGps()
    const timeoutID = window.setInterval(
      () => {
        sendGeoLocation(this.getProjectId, this.getQRCode, 'Welcome')
      }, 30000
    )
    window.localStorage.setItem('gpsTimeID', timeoutID.toString())
    if (!_.isNull(this.getAllMarkers) && !_.isNull(this.getProjectId) && !_.isNull(this.getQRCode) && !_.isNull(window.localStorage.getItem('userId'))) {
      this.$router.push({ name: 'follow', params: { prjId: this.$route.params.prjId } })
    }
  },
  mounted () {
    if (CheckUtil.browseInAppCheck()) {
    }
    this.isTrackingAllowed = this.getIsTrackingAllowed
  }
}
</script>
